import React from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HorseResultsTable from './HorseResultsTable'
import { getOrdinal } from '../helper/getOrdinal'
import { convertToCamelCase } from '../helper/convertToCamelCase'
import { formatDate } from '../helper/formatDate'
import { useTranslate } from './TranslationText';
import JudgeCard from './JudgeCard';

export default function HorseList({ showData ,item, isChampion = false, isFromJson = true, isFireStore = false, horse, expanded, index, handleChange, islive, currentHorseData, handleHorseimages, selectedHorseId, horsesRef }) {
    const { translate } = useTranslate();
    const currentLanguage = localStorage.getItem('ecupLang') ?? 'en';

    const isExpanded = expanded === ('panelHorse' + index);

    const displayHorse = (isFireStore && isExpanded && selectedHorseId === horse?.id)
        ? { ...horse, ...currentHorseData }
        : horse;

    const hasPoints = Number(displayHorse?.totalPoint) > 0;

    const galleryCheck = horse?.classHorseGallery?.length > 0;
    const galleryData = horse?.classHorseGallery ?? [];

    return (
        <Accordion
            ref={(el) => (horsesRef && (horsesRef.current[horse?.id?.toLowerCase()] = el))}
            key={displayHorse?.id + 'panelHorse' + displayHorse?.horseName}
            expanded={isExpanded}
            onChange={handleChange(('panelHorse' + index), displayHorse?.id, displayHorse?.horseNumber)}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-content"
                id="panel-header"

            >
                <div className='row w-100'>
                    <div className='col-sm-3 col-6' dangerouslySetInnerHTML={{ __html: getOrdinal(displayHorse?.rank, currentLanguage , isChampion) }} />
                    <div className='col-sm-3 col-6 '>{displayHorse?.horseNumber} – {displayHorse?.horseName}</div>
                    <div className='col-sm-3 col-6 text-center'>{hasPoints ? Number(displayHorse?.totalPoint)?.toFixed(2) : ''} {!!displayHorse?.reason && '' + translate('web.' + convertToCamelCase(displayHorse?.reason), displayHorse?.reason)}</div>
                    <div className='col-sm-2 col-6 text-end'>

                        {translate('web.results', 'Results')}

                    </div>
                    <div className='col-sm-1 col-6 text-end'>
                        {galleryCheck &&
                            <div className='me-3 border-0 ' style={{ cursor: 'pointer' }} title={translate('web.viewHorseImages', 'View Horse Images')} onClick={(e) => (e.stopPropagation(), handleHorseimages(galleryData))}>
                                <i className="fa-solid fa-film"></i>
                            </div>
                        }

                    </div>
                </div>
            </AccordionSummary>
            <AccordionDetails>
                <div className='row w-100 position-relative'>
                    <div className='col-lg-4 mt-2 col-md-4 col-sm-6 col-12'>
                        <h6 className='roboto-light'>
                            {translate('web.birthdate', 'Birthdate')}
                        </h6>
                        <span>{displayHorse?.birthDate && formatDate(displayHorse?.birthDate)}</span>
                    </div>
                    <div className='col-lg-4 mt-2 col-md-4 col-sm-6 col-12'>
                        <h6 className='roboto-light'>
                            {translate('web.sire', 'Sire')}
                        </h6>
                        <span style={{ textTransform: 'uppercase' }}>{displayHorse?.sire}</span>
                    </div>
                    <div className='col-lg-4 mt-2 col-md-4 col-sm-6 col-12'>
                        <h6 className='roboto-light'>
                            {translate('web.breeder', 'Breeder')}
                        </h6>
                        <span style={{ textTransform: 'uppercase' }}>{displayHorse?.breeder}</span>
                    </div>
                    <div className='col-lg-4 mt-2 col-md-4 col-sm-6 col-12'>
                        <h6 className='roboto-light'>
                            {translate('web.color', 'Color')}
                        </h6>
                        <span style={{ textTransform: 'uppercase' }}>{displayHorse?.color}</span>
                    </div>
                    <div className='col-lg-4 mt-2 col-md-4 col-sm-6 col-12'>
                        <h6 className='roboto-light'>
                            {translate('web.dam', 'Dam')}
                        </h6>
                        <span style={{ textTransform: 'uppercase' }}>{displayHorse?.dam}</span>
                    </div>
                    <div className='col-lg-4 mt-2 col-md-4 col-sm-6 col-12'>
                        <h6 className='roboto-light'>
                            {translate('web.owner', 'Owner')}
                        </h6>
                        <span style={{ textTransform: 'uppercase' }}>{displayHorse?.owner}</span>
                    </div>
                    {!isFromJson && isChampion && isExpanded && <JudgeCard championId={item?.championshipId} horseId={displayHorse?.id} />}
                    {hasPoints &&
                        <div className='col-12 mt-2 overflow-auto'>
                            {!isFromJson && !isChampion && <HorseResultsTable showData={showData} key={'Horse Data'} currentHorseData={isFireStore ? displayHorse : currentHorseData} />}
                            {!isFireStore && displayHorse?.classHorseScoringModel?.scoringTable?.length > 0 &&
                                <sub className='mt-2'>
                                    {translate('web.judge', 'Judges')}: {displayHorse?.classHorseScoringModel?.scoringTable?.map((judgeContainer, index) => (`${judgeContainer?.judgeLetter} - ${judgeContainer?.judgeName}${(index + 1 !== displayHorse?.classHorseScoringModel?.scoringTable?.length) ? ', ' : ''}`))}
                                </sub>
                            }
                        </div>
                    }
                </div>
            </AccordionDetails>
        </Accordion>
    )
}
